import React, { Component } from 'react';
import glamorous from 'glamorous';
import Colors from '../../styles/colors';

export const StatusCodes = {
    STATUS_CODE_401: 401,
    STATUS_CODE_403: 403,
    STATUS_CODE_404: 404
  }

const ErrorViewContainer = glamorous.div({
    position: 'absolute',
    alignItems: 'center',
    backgroundColor: Colors.background.GRAY_BLUE,
    display: 'flex',
    flex: 'auto',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  });

const ErrorNumberContainer = glamorous.h1({
    float: 'left',
    marginRight: 20,
    fontSize: 250,
    color: Colors.tableHeadingText
});

const ErrorMessageContainer = glamorous.h1({
    float: 'left',
    marginLeft: 20,
    marginTop: 100
});

const ErrorContainer = glamorous.form({
    padding: 0,
    display: 'block'
});

const PrimaryMessage = glamorous.span({
    display: 'block', 
    fontSize: 40,
    color: Colors.tableHeadingText,
    marginTop: 50
});

const SecondaryMessage = glamorous.p({
    textAlign: 'center', 
    fontWeight: 400, 
    color: Colors.tableHeadingText
});

class ErrorView extends Component {
    constructor(proops) {
        super()
        this.goBack = this.goBack.bind(this);
        this.goHome = this.goHome.bind(this);
        this.login = this.login.bind(this);
        this.getPrimaryMessage = this.getPrimaryMessage.bind(this);
        this.getSecondaryMessage = this.getSecondaryMessage.bind(this);
    }

    goHome() {
        window.location.href = '/';
    }

    goBack() {
        const { history } = this.props;
        history.goBack();
    }

    login() {
        const { auth } = this.props;
        auth.logout();
        auth.login();
    }

    getPrimaryMessage(statusCode) {
        switch(statusCode) {
            case StatusCodes.STATUS_CODE_401:
                return 'UNAUTHORIZED';
            case StatusCodes.STATUS_CODE_403:
                return 'ACCESS FORBIDDEN';
            case StatusCodes.STATUS_CODE_404:
                return 'PAGE NOT FOUND'; 
            default:
                break;
        }
    }

    getSecondaryMessage(statusCode) {
        switch(statusCode) {
            case StatusCodes.STATUS_CODE_401:
                return 'Access Is Allowed Only For Authenticated Users. Login Or Contact Your System Administrator To Provide You Access.';
            case StatusCodes.STATUS_CODE_403:
                return 'You Are Not Authorized To Access The Page You Requested.';
            case StatusCodes.STATUS_CODE_404:
                return 'The Page You Requested Could Not Be Found On Our Server.';
            default:
                break;
        }
    }

    render() {
        const { statusCode } = this.props;
        const hyperLinks = (statusCode === StatusCodes.STATUS_CODE_401) ? 
            (
                <p style={{textAlign: 'center', fontWeight: 400, color: Colors.tableHeadingText}}>
                    <a style={{color: Colors.GREEN}} onClick={this.login} > &laquo; Login</a>
                </p>
            ) : 
            (
                <p style={{textAlign: 'center', fontWeight: 400, color: Colors.tableHeadingText}}>
                    <a style={{color: Colors.GREEN}} onClick={this.goBack} > &laquo; Go Back</a> / <a style={{color: Colors.GREEN}} onClick={this.goHome}>Go Home &raquo;</a>
                </p>
            );

        return (
            <ErrorViewContainer>
                <ErrorContainer>
                    <ErrorNumberContainer>
                        {statusCode}
                    </ErrorNumberContainer>
                    <ErrorMessageContainer>
                        <PrimaryMessage>{this.getPrimaryMessage(statusCode)}</PrimaryMessage>
                    </ErrorMessageContainer>
                </ErrorContainer>
                <ErrorContainer style={{marginTop: '-30px'}}>
                    <SecondaryMessage>{this.getSecondaryMessage(statusCode)}</SecondaryMessage>                                                      
                </ErrorContainer>
                <ErrorContainer style={{marginTop: '10px'}}>                    
                    {hyperLinks}                    
                </ErrorContainer>
            </ErrorViewContainer>    
        );
    }
}

export default ErrorView;


// WEBPACK FOOTER //
// ./src/modules/errors/ErrorView.js